"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeMidday = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const TimeMidday = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("circle", { cx: "8", cy: "8", r: "3", fill: "#B5C2CA" }),
    react_1.default.createElement("path", { d: "M7 4L8 2L9 4H7Z", fill: "#B5C2CA" }),
    react_1.default.createElement("path", { d: "M9 12L8 14L7 12L9 12Z", fill: "#B5C2CA" }),
    react_1.default.createElement("path", { d: "M12 7L14 8L12 9L12 7Z", fill: "#B5C2CA" }),
    react_1.default.createElement("path", { d: "M4 9L2 8L4 7L4 9Z", fill: "#B5C2CA" }),
    react_1.default.createElement("path", { d: "M10.1213 4.46499L12.2426 3.75789L11.5355 5.87921L10.1213 4.46499Z", fill: "#B5C2CA" }),
    react_1.default.createElement("path", { d: "M5.87868 11.535L3.75736 12.2421L4.46446 10.1208L5.87868 11.535Z", fill: "#B5C2CA" }),
    react_1.default.createElement("path", { d: "M11.5355 10.1209L12.2426 12.2423L10.1213 11.5352L11.5355 10.1209Z", fill: "#B5C2CA" }),
    react_1.default.createElement("path", { d: "M4.46446 5.87906L3.75735 3.75774L5.87867 4.46484L4.46446 5.87906Z", fill: "#B5C2CA" })));
exports.TimeMidday = TimeMidday;
exports.default = exports.TimeMidday;
